// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowCurved: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11">
            <path
                fill="#4D4D4D"
                d="M1.3125,1.15625 C1.3125,0.80078125 1.01171875,0.5 0.65625,0.5 C0.30078125,0.5 0,0.80078125 0,1.15625 L0,3.78125 C0,5.23046875 1.17578125,6.40625 2.625,6.40625 L11.7578125,6.40625 L9.16015625,9.00390625 C8.9140625,9.25 8.9140625,9.6875 9.16015625,9.93359375 C9.43359375,10.1796875 9.84375,10.1796875 10.0898438,9.93359375 L13.8085938,6.21484375 C13.9453125,6.10546875 14,5.9140625 14,5.75 C14,5.5859375 13.9453125,5.421875 13.8085938,5.28515625 L10.0898438,1.56640625 C9.84375,1.3203125 9.40625,1.3203125 9.16015625,1.56640625 C8.9140625,1.8125 8.9140625,2.25 9.16015625,2.49609375 L11.7578125,5.09375 L2.625,5.09375 C1.9140625,5.09375 1.3125,4.4921875 1.3125,3.78125 L1.3125,1.15625 Z"
            />
        </svg>
    );
};

export default React.memo(IconArrowCurved);
